import { render, staticRenderFns } from "./annual-procurement.vue?vue&type=template&id=45b401a8&"
import script from "./annual-procurement.vue?vue&type=script&lang=js&"
export * from "./annual-procurement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports